import { MoreVertical, ChevronLeft } from "lucide-react";
import { useChatStore } from "@/store/chatStore";
import { useIsMobile } from "@/hooks/use-media-query";
import { Button } from "@/components/ui/button";
import { Avatar } from "@/components/ui/chat-avatar";
import { ThemeColorPicker } from "@/components/theme-color-picker";
import { NetworkStatusCompact } from "@/components/ui/network-status";

export function ChatHeader() {
  const { selectedRoomId, setSelectedRoom,rooms } = useChatStore();
  const room = rooms?.find(item=>item.id == selectedRoomId);
  const isMobile = useIsMobile();

  const handleBack = () => {
    setSelectedRoom(null);
  };

  if (!room) {
    return (
      <header className="flex items-center justify-between p-4 border-b border-border">
        <p className="text-sm text-muted-foreground">Select a chat to get started</p>
        <div className="flex items-center gap-2">
          <NetworkStatusCompact />
          <ThemeColorPicker />
        </div>
      </header>
    );
  }

  const roomName = room.name;
  const roomAvatar = room.image;

  return (
    <header className="flex items-center justify-between p-4 border-b border-border">
      <div className="flex items-center gap-3">
        {isMobile && (
          <Button
            variant="ghost"
            size="icon"
            onClick={handleBack}
            className="mr-2 hover:bg-[#D8902F]/10"
          >
            <ChevronLeft className="h-5 w-5" />
          </Button>
        )}
        <Avatar src={roomAvatar} alt={roomName!} />
        {roomName && <p className="text-xl font-bold">{roomName}</p>}
      </div>
      <div className="flex items-center gap-2">
        <NetworkStatusCompact />
        <ThemeColorPicker />
        <Button variant="ghost" size="icon" className="hover:bg-[#D8902F]/80">
          <MoreVertical className="h-5 w-5" />
        </Button>
      </div>
    </header>
  );
}